
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as abrechnung8nRAoOSKnnMeta } from "/app/pages/dashboard/abrechnung.vue?macro=true";
import { default as administrative_45aufgabenSI4NJOlUc8Meta } from "/app/pages/dashboard/administrative-aufgaben.vue?macro=true";
import { default as aktuellesvIbhoRUU5DMeta } from "/app/pages/dashboard/aktuelles.vue?macro=true";
import { default as auslastungDHvrvbvLcvMeta } from "/app/pages/dashboard/auslastung.vue?macro=true";
import { default as indexUrNAo8epHvMeta } from "/app/pages/dashboard/datenbank-templates/[id]/index.vue?macro=true";
import { default as previewfeAVSCw446Meta } from "/app/pages/dashboard/datenbank-templates/[id]/preview.vue?macro=true";
import { default as index9RqSAGuONwMeta } from "/app/pages/dashboard/datenbank-templates/index.vue?macro=true";
import { default as einstellungen8oAQuKN2v0Meta } from "/app/pages/dashboard/einstellungen.vue?macro=true";
import { default as gruppenverwaltung3i2AOtXvWtMeta } from "/app/pages/dashboard/gruppenverwaltung.vue?macro=true";
import { default as indexhg2nWJrbRRMeta } from "/app/pages/dashboard/index.vue?macro=true";
import { default as knowledgeehLKzUmQC5Meta } from "/app/pages/dashboard/knowledge.vue?macro=true";
import { default as indexIBXlXkWQLBMeta } from "/app/pages/dashboard/meine-datenbanken/[id]/index.vue?macro=true";
import { default as previewCPQcBaJhhRMeta } from "/app/pages/dashboard/meine-datenbanken/[id]/preview.vue?macro=true";
import { default as index4CpZB9R8bJMeta } from "/app/pages/dashboard/meine-datenbanken/index.vue?macro=true";
import { default as meineaboseLQRxuDFeLMeta } from "/app/pages/dashboard/meineabos.vue?macro=true";
import { default as produktverwaltungenFF7vW0CtduMeta } from "/app/pages/dashboard/produktverwaltungen.vue?macro=true";
import { default as teamverwaltungenJqisW54eURMeta } from "/app/pages/dashboard/teamverwaltungen.vue?macro=true";
import { default as indexxQESz992T0Meta } from "/app/pages/datenbank/[slug]/index.vue?macro=true";
import { default as indexnbOmN9xmisMeta } from "/app/pages/datenbank/[slug]/login/index.vue?macro=true";
import { default as datenschutzbestimmungenYOGXXxlDKQMeta } from "/app/pages/datenschutzbestimmungen.vue?macro=true";
import { default as impressumLDkFRkkSAmMeta } from "/app/pages/impressum.vue?macro=true";
import { default as indexN6pT4Un8hYMeta } from "/app/pages/index.vue?macro=true";
import { default as kontaktzJWjXi4cLvMeta } from "/app/pages/kontakt.vue?macro=true";
import { default as loginhHM0vSTW5jMeta } from "/app/pages/login.vue?macro=true";
import { default as nutzungsbedingungenGA8xzIiboJMeta } from "/app/pages/nutzungsbedingungen.vue?macro=true";
import { default as basketAmjKRsapvwMeta } from "/app/pages/produkte/shop/basket.vue?macro=true";
import { default as cancelpj2BhPFBOQMeta } from "/app/pages/produkte/shop/cancel.vue?macro=true";
import { default as loginqSS7TanHthMeta } from "/app/pages/produkte/shop/login.vue?macro=true";
import { default as successtxqbibvDueMeta } from "/app/pages/produkte/shop/success.vue?macro=true";
import { default as registrationre4qBsMVLdMeta } from "/app/pages/registration.vue?macro=true";
import { default as previewYw5YMoIrNOMeta } from "/app/pages/template/[slug]/preview.vue?macro=true";
export default [
  {
    name: "dashboard-abrechnung",
    path: "/dashboard/abrechnung",
    meta: abrechnung8nRAoOSKnnMeta || {},
    component: () => import("/app/pages/dashboard/abrechnung.vue")
  },
  {
    name: "dashboard-administrative-aufgaben",
    path: "/dashboard/administrative-aufgaben",
    meta: administrative_45aufgabenSI4NJOlUc8Meta || {},
    component: () => import("/app/pages/dashboard/administrative-aufgaben.vue")
  },
  {
    name: "dashboard-aktuelles",
    path: "/dashboard/aktuelles",
    meta: aktuellesvIbhoRUU5DMeta || {},
    component: () => import("/app/pages/dashboard/aktuelles.vue")
  },
  {
    name: "dashboard-auslastung",
    path: "/dashboard/auslastung",
    meta: auslastungDHvrvbvLcvMeta || {},
    component: () => import("/app/pages/dashboard/auslastung.vue")
  },
  {
    name: "dashboard-datenbank-templates-id",
    path: "/dashboard/datenbank-templates/:id()",
    meta: indexUrNAo8epHvMeta || {},
    component: () => import("/app/pages/dashboard/datenbank-templates/[id]/index.vue")
  },
  {
    name: "dashboard-datenbank-templates-id-preview",
    path: "/dashboard/datenbank-templates/:id()/preview",
    meta: previewfeAVSCw446Meta || {},
    component: () => import("/app/pages/dashboard/datenbank-templates/[id]/preview.vue")
  },
  {
    name: "dashboard-datenbank-templates",
    path: "/dashboard/datenbank-templates",
    meta: index9RqSAGuONwMeta || {},
    component: () => import("/app/pages/dashboard/datenbank-templates/index.vue")
  },
  {
    name: "dashboard-einstellungen",
    path: "/dashboard/einstellungen",
    meta: einstellungen8oAQuKN2v0Meta || {},
    component: () => import("/app/pages/dashboard/einstellungen.vue")
  },
  {
    name: "dashboard-gruppenverwaltung",
    path: "/dashboard/gruppenverwaltung",
    meta: gruppenverwaltung3i2AOtXvWtMeta || {},
    component: () => import("/app/pages/dashboard/gruppenverwaltung.vue")
  },
  {
    name: "dashboard",
    path: "/dashboard",
    meta: indexhg2nWJrbRRMeta || {},
    component: () => import("/app/pages/dashboard/index.vue")
  },
  {
    name: "dashboard-knowledge",
    path: "/dashboard/knowledge",
    meta: knowledgeehLKzUmQC5Meta || {},
    component: () => import("/app/pages/dashboard/knowledge.vue")
  },
  {
    name: "dashboard-meine-datenbanken-id",
    path: "/dashboard/meine-datenbanken/:id()",
    meta: indexIBXlXkWQLBMeta || {},
    component: () => import("/app/pages/dashboard/meine-datenbanken/[id]/index.vue")
  },
  {
    name: "dashboard-meine-datenbanken-id-preview",
    path: "/dashboard/meine-datenbanken/:id()/preview",
    meta: previewCPQcBaJhhRMeta || {},
    component: () => import("/app/pages/dashboard/meine-datenbanken/[id]/preview.vue")
  },
  {
    name: "dashboard-meine-datenbanken",
    path: "/dashboard/meine-datenbanken",
    meta: index4CpZB9R8bJMeta || {},
    component: () => import("/app/pages/dashboard/meine-datenbanken/index.vue")
  },
  {
    name: "dashboard-meineabos",
    path: "/dashboard/meineabos",
    meta: meineaboseLQRxuDFeLMeta || {},
    component: () => import("/app/pages/dashboard/meineabos.vue")
  },
  {
    name: "dashboard-produktverwaltungen",
    path: "/dashboard/produktverwaltungen",
    meta: produktverwaltungenFF7vW0CtduMeta || {},
    component: () => import("/app/pages/dashboard/produktverwaltungen.vue")
  },
  {
    name: "dashboard-teamverwaltungen",
    path: "/dashboard/teamverwaltungen",
    meta: teamverwaltungenJqisW54eURMeta || {},
    component: () => import("/app/pages/dashboard/teamverwaltungen.vue")
  },
  {
    name: "datenbank-slug",
    path: "/datenbank/:slug()",
    meta: indexxQESz992T0Meta || {},
    component: () => import("/app/pages/datenbank/[slug]/index.vue")
  },
  {
    name: "datenbank-slug-login",
    path: "/datenbank/:slug()/login",
    meta: indexnbOmN9xmisMeta || {},
    component: () => import("/app/pages/datenbank/[slug]/login/index.vue")
  },
  {
    name: "datenschutzbestimmungen",
    path: "/datenschutzbestimmungen",
    meta: datenschutzbestimmungenYOGXXxlDKQMeta || {},
    component: () => import("/app/pages/datenschutzbestimmungen.vue")
  },
  {
    name: "impressum",
    path: "/impressum",
    meta: impressumLDkFRkkSAmMeta || {},
    component: () => import("/app/pages/impressum.vue")
  },
  {
    name: "index",
    path: "/",
    meta: indexN6pT4Un8hYMeta || {},
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "kontakt",
    path: "/kontakt",
    meta: kontaktzJWjXi4cLvMeta || {},
    component: () => import("/app/pages/kontakt.vue")
  },
  {
    name: "login",
    path: "/login",
    meta: loginhHM0vSTW5jMeta || {},
    component: () => import("/app/pages/login.vue")
  },
  {
    name: "nutzungsbedingungen",
    path: "/nutzungsbedingungen",
    meta: nutzungsbedingungenGA8xzIiboJMeta || {},
    component: () => import("/app/pages/nutzungsbedingungen.vue")
  },
  {
    name: "produkte-shop-basket",
    path: "/produkte/shop/basket",
    meta: basketAmjKRsapvwMeta || {},
    component: () => import("/app/pages/produkte/shop/basket.vue")
  },
  {
    name: "produkte-shop-cancel",
    path: "/produkte/shop/cancel",
    meta: cancelpj2BhPFBOQMeta || {},
    component: () => import("/app/pages/produkte/shop/cancel.vue")
  },
  {
    name: "produkte-shop-login",
    path: "/produkte/shop/login",
    meta: loginqSS7TanHthMeta || {},
    component: () => import("/app/pages/produkte/shop/login.vue")
  },
  {
    name: "produkte-shop-success",
    path: "/produkte/shop/success",
    meta: successtxqbibvDueMeta || {},
    component: () => import("/app/pages/produkte/shop/success.vue")
  },
  {
    name: "registration",
    path: "/registration",
    meta: registrationre4qBsMVLdMeta || {},
    component: () => import("/app/pages/registration.vue")
  },
  {
    name: "template-slug-preview",
    path: "/template/:slug()/preview",
    meta: previewYw5YMoIrNOMeta || {},
    component: () => import("/app/pages/template/[slug]/preview.vue")
  }
]